<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch6">
<div class="chapterHead">
<p class="centerImage3"><img alt="image" src="images/ch6.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-6">“Let’s go look for my mom,” you tell Sam. “But remember — no goofing around. This is a science lab.”</a></p><a id="pg-6">
<p class="para" style="text-indent: 5%;">“Right,” Sam agrees. He zooms through the waiting room door into a long hallway. You quickly follow.</p>
<p class="para" style="text-indent: 5%;">Hmmm. The hallway is pretty boring. Just a lot of closed doors on both white walls. And there’s no way to know what’s behind most of them.</p>
<p class="para" style="text-indent: 5%;">You open the first one and peek in.</p>
<p class="para" style="text-indent: 5%;">Bummer. It’s just the lounge. At least that’s what it looks like. There are two beat-up brown couches, a table, some chairs, and a bunch of vending machines.</p>
<p class="para" style="text-indent: 5%;">“Got any change?” Sam asks. “I’m starving.”</p>
<p class="para" style="text-indent: 5%;">You pull out coins from your pocket. You’ve got enough for only one snack selection. You drop the coins into the slot in the machine. You start to punch the number of your favorite candy bar.</p>
<p class="para" style="text-indent: 5%;">But before you can hit the buttons, a hand suddenly clamps down on your shoulder!</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-6"><em class="italic">Turn around slowly on</em> </a><span href="#/e9780545841054_ch014" title="Link target outside of Sample"><em class="italic">PAGE 14</em></span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch006.vue?5b1fe93a